module.exports = __webpack_public_path__ + "static/media/trade.0f6af890.jpg";